<template>
    <v-container class="contentview">
        <p></p>
        <p></p>
        <span v-html="HTMLcontent"></span>
        <p></p>
        <p></p>
    </v-container>
</template>

<script>

export default {
    name: 'ContentView',
    data: () => ({
        HTMLcontent: ""
    }),
    mounted: function () {
        this.loaddata();
    },
    methods: {
        loaddata: function () {
            var txt = "";
            this.txt = txt;
            var r = this.$router.currentRoute;
            var path = "texts" + r.fullPath + ".txt"
            //console.log(path);
            const baseURI = path;
            this.$http.get(baseURI)
                .then((result) => {
                    this.HTMLcontent = result.data;
                })
        }
    },
    watch: {
        $route(/*to, from*/) {
            //console.log(to);
            //console.log(from);
            this.loaddata();
        }
    },
}
</script>

<style>
a {
    white-space: nowrap;
    color: black;
    text-decoration: none;
}
</style>